const GlobalAlerts = require('../functions/GlobalAlerts');
const Lang = require('lang');

function reprovarRelatorios() {
  const body = nifty.body;
  const modalReprovar = $('#reprovar');
  const reprovarBtn = document.querySelector('#reprovar-relatorio');
  const form = document.querySelector('#formValidacao');
  const justificativa = document.querySelector('#justificativa');
  if (reprovarBtn) {
    const url = reprovarBtn.dataset.url;

    // adiciona evento ao botão reprovar
    reprovarBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(form).validate()
      if (!$(form).valid()) {
        return;
      }

      let idDespesa = null;

      if (document.getElementById('idDespesa')) {
        idDespesa = document.getElementById('idDespesa').value;
      } else {
        const item = document.querySelector('.item') ;
        idDespesa = item.dataset.value;
      }

      // chama a função que envia o relatório para verificar se contém despesas convertidas
      sendRequest(url, idDespesa)
        .done(function (data) {
          if (data.data) {
            // chama função que exibe o modal de alerta de despesas convertidas
            modalAvisoConversao(modalReprovar, form, body, justificativa);
          } else {
            // chama funçaõ que exibe o modal para inserir justificativa e reprovar
            modalJustificativa(modalReprovar, form, body, justificativa);
          }
        })
        .fail(function (error) {
          // chama função que exibe mensagem de erro
          showMessage(error.responseJSON.message, 'danger');
        });
    });
  }
}

// exibe modal com campo para inserir justificativa para a reprovação do relatório
function modalJustificativa(modal, form, body, justificativa) {
  modal.modal('show');
  modal.find('.btn-confirmation').click(function () {
    submit(body, form, justificativa);
  })
}

// Exibe o modal com mensagem de aviso de despesa convertida
function modalAvisoConversao(modalReprovar, form, body, justificativa) {
  const modal = bootbox.dialog({
    title: Lang.get('js/src/events/reprovarRelatorios.converted_expenses'),
    message: Lang.get('js/src/events/reprovarRelatorios.there_are_expenses_converted_proceed_with_disapproval'),
    buttons: {
      cancel: {
        label: Lang.get('js/src/events/reprovarRelatorios.cancel'),
        className: 'btn-default'
      },
      confirm: {
        label: Lang.get('js/src/events/reprovarRelatorios.proceed'),
        className: 'btn-success',
        callback: function () {
          modalJustificativa(modalReprovar, form, body, justificativa);
        }
      }
    }
  })
}

// requisição para a verificação se existe despesa convertida no relatorio
function sendRequest(url, idDespesa) {
  return $.ajax({
    method: 'POST',
    url: url,
    data: { 'idDespesa': idDespesa }
  });
}

// Envia o form com os dados para reprovar o relatório
function submit(body, form, justificativa) {
  const justificativaReprovar = document.querySelector('#justificativaReprovar');
  body.overlay('show');
  justificativa.value = justificativaReprovar.value;
  form.submit();
}

// Exibe a mensagem de erro ou sucesso
function showMessage(message, type) {
  GlobalAlerts.createAndShow({
    type: type,
    title: '',
    message: message
  });
}

exports.init = reprovarRelatorios;
